function strictNotEqual(a, b) {
  return a !== b;
}

strictNotEqual.op = '!==';

export default strictNotEqual;
